module.exports = __webpack_public_path__ + "img/events2.85355a99.png";